import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '../components/auth0/AuthProvider';

const AspIntakeWelcomePage = lazy(() => import('app-pages/pages/asp/intake/AspIntakeWelcomePage'));
const AspIntakeLeadInfoPage = lazy(() => import('app-pages/pages/asp/intake/AspIntakeLeadInfoPage'));
const AspIntakeInsurancePage = lazy(() => import('app-pages/pages/asp/intake/AspIntakeInsurancePage'));
const AspIntakeAgreementsPage = lazy(() => import('app-pages/pages/asp/intake/AspIntakeAgreementsPage'));
const AspIntakeFinRespPage = lazy(() => import('app-pages/pages/asp/intake/AspIntakeFinRespPage'));
const AspIntakeSuccessPage = lazy(() => import('app-pages/pages/asp/intake/AspIntakeSuccessPage'));

export function AspRoutes() {
  return (
    <Routes>
      <Route path="welcome" element={<ProtectedRoute component={AspIntakeWelcomePage} />} />
      <Route path="info" element={<ProtectedRoute component={AspIntakeLeadInfoPage} />} />
      <Route path="insurance" element={<ProtectedRoute component={AspIntakeInsurancePage} />} />
      <Route path="agreements" element={<ProtectedRoute component={AspIntakeAgreementsPage} />} />
      <Route path="financial-responsibility" element={<ProtectedRoute component={AspIntakeFinRespPage} />} />
      <Route path="success" element={<ProtectedRoute component={AspIntakeSuccessPage} />} />
    </Routes>
  );
}
